import React, { memo } from 'react';

import { IconButton, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

import { FEEDBACK_ICON_SIZE } from './FeedbackButtons.constants';
import { filledFeedbackButtonStyles, unfilledFeedbackButtonStyles } from './FeedbackButtons.styles';

const FeedbackButton = ({ Icon, label, isFilled, isHidden = false, testId, onClick }) => {
  if (isHidden) {
    return null;
  }

  return (
    <Tooltip title={label}>
      <IconButton
        aria-label={label}
        data-testid={testId}
        size="small"
        sx={isFilled ? filledFeedbackButtonStyles : unfilledFeedbackButtonStyles}
        onClick={onClick}
      >
        <Icon size={FEEDBACK_ICON_SIZE} />
      </IconButton>
    </Tooltip>
  );
};

FeedbackButton.propTypes = {
  Icon: PropTypes.elementType.isRequired,
  label: PropTypes.string.isRequired,
  isFilled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  isHidden: PropTypes.bool,
  testId: PropTypes.string,
};

export default memo(FeedbackButton);
